import React from 'react';
import {Text, IconButton} from '@wix/wix-ui-tpa/cssVars';
import {Edit as EditIcon} from '@wix/wix-ui-icons-common/on-stage';
import {classes} from './SummaryTitle.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {BiMobilePosition} from '../../../../domain/utils/bi.util';
import {A11yIds} from '../../../../common/constants';

export enum SummaryTitleDataHooks {
  root = 'SummaryTitleDataHooks.root',
  titleText = 'SummaryTitleDataHooks.title',
  editCartButton = 'SummaryTitleDataHooks.editCartButton',
  editCartIconButton = 'SummaryTitleDataHooks.editCartIconButton',
  numberOfItems = 'SummaryTitleDataHooks.numberOfItems',
}
export const SummaryTitle = () => {
  const localeKeys = useLocaleKeys();
  const {
    navigationStore: {editCartUrl, clickOnEditCart, isDonationsTheme},
    checkoutStore: {cart},
    checkoutSettingsStore: {checkoutContent},
    isOneColumnView,
  } = useControllerProps();
  const summaryTitleText = isDonationsTheme
    ? localeKeys.checkout.donations.donation_summary()
    : localeKeys.checkout.order_summary.$value();
  const summaryTitleTextWithOverride = checkoutContent?.orderSummary ?? summaryTitleText;

  const numberOfItemsText = localeKeys.checkout.order_summary.numberOfItems({
    numberOfItems: cart.numberOfItems,
  });
  const handleEditCartClick = () => {
    clickOnEditCart(isOneColumnView ? BiMobilePosition.top : undefined);
  };

  return (
    <div data-hook={SummaryTitleDataHooks.root} className={classes.title} id={A11yIds.SummarySection}>
      <div className={classes.header}>
        <Text tagName={'h2'} className={classes.titleText} data-hook={SummaryTitleDataHooks.titleText}>
          {summaryTitleTextWithOverride}
        </Text>{' '}
        <Text
          data-hook={SummaryTitleDataHooks.numberOfItems}
          className={classes.numberOfItems}
          aria-label={localeKeys.checkout.orderSummary.itemAmount_ariaLabel({
            itemNumber: cart.numberOfItems,
          })}>
          {numberOfItemsText}
        </Text>
      </div>
      {cart.currentCart && (
        <div className={classes.editCartButtonWrapper}>
          <IconButton
            as={'a'}
            href={editCartUrl}
            onClick={handleEditCartClick}
            className={classes.editCartButton}
            icon={<EditIcon />}
            aria-label={localeKeys.checkout.edit_cart()}
            data-hook={SummaryTitleDataHooks.editCartIconButton}
          />
        </div>
      )}
    </div>
  );
};
